namespace RecordShield.Workspace {
    export interface ProductItemsRow {
        Id?: number;
        Name?: string;
        MIMEType?: string;
        Length?: number;
        Size?: number;
        SortOrder?: number;
        ContentKey?: number;
        CustomerKey?: number;
        Sync?: boolean;
        SyncDate?: string;
        Extension?: string;
        ProductId?: number;
        Code?: number;
        ContentTypeId?: number;
        EncryptionKeyId?: number;
        EncryptedName?: string;
        EncryptionPath?: string;
        IsActive?: number;
        ProductCode?: number;
        ProductName?: string;
        ProductDescription?: string;
        ProductUserId?: number;
        ProductViews?: number;
        ProductWatchTime?: number;
        ProductValidityInDays?: number;
        ProductUpdateFrequencyInDays?: number;
        ProductAllowSecondScreen?: boolean;
        ProductInsertDate?: string;
        ProductInsertUserId?: number;
        ProductUpdateDate?: string;
        ProductUpdateUserId?: number;
        ProductIsActive?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ProductItemsRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Workspace.ProductItems';
        export const lookupKey = 'Workspace.ProductItems';

        export function getLookup(): Q.Lookup<ProductItemsRow> {
            return Q.getLookup<ProductItemsRow>('Workspace.ProductItems');
        }

        export namespace Fields {
            export declare const Id: string;
            export declare const Name: string;
            export declare const MIMEType: string;
            export declare const Length: string;
            export declare const Size: string;
            export declare const SortOrder: string;
            export declare const ContentKey: string;
            export declare const CustomerKey: string;
            export declare const Sync: string;
            export declare const SyncDate: string;
            export declare const Extension: string;
            export declare const ProductId: string;
            export declare const Code: string;
            export declare const ContentTypeId: string;
            export declare const EncryptionKeyId: string;
            export declare const EncryptedName: string;
            export declare const EncryptionPath: string;
            export declare const IsActive: string;
            export declare const ProductCode: string;
            export declare const ProductName: string;
            export declare const ProductDescription: string;
            export declare const ProductUserId: string;
            export declare const ProductViews: string;
            export declare const ProductWatchTime: string;
            export declare const ProductValidityInDays: string;
            export declare const ProductUpdateFrequencyInDays: string;
            export declare const ProductAllowSecondScreen: string;
            export declare const ProductInsertDate: string;
            export declare const ProductInsertUserId: string;
            export declare const ProductUpdateDate: string;
            export declare const ProductUpdateUserId: string;
            export declare const ProductIsActive: string;
            export declare const InsertUserId: string;
            export declare const InsertDate: string;
            export declare const UpdateUserId: string;
            export declare const UpdateDate: string;
        }

        ['Id', 'Name', 'MIMEType', 'Length', 'Size', 'SortOrder', 'ContentKey', 'CustomerKey', 'Sync', 'SyncDate', 'Extension', 'ProductId', 'Code', 'ContentTypeId', 'EncryptionKeyId', 'EncryptedName', 'EncryptionPath', 'IsActive', 'ProductCode', 'ProductName', 'ProductDescription', 'ProductUserId', 'ProductViews', 'ProductWatchTime', 'ProductValidityInDays', 'ProductUpdateFrequencyInDays', 'ProductAllowSecondScreen', 'ProductInsertDate', 'ProductInsertUserId', 'ProductUpdateDate', 'ProductUpdateUserId', 'ProductIsActive', 'InsertUserId', 'InsertDate', 'UpdateUserId', 'UpdateDate'].forEach(x => (<any>Fields)[x] = x);
    }
}
